import { CanDeactivateComponent } from '../can-deactivate/component-can-deactivate';
import { NgForm } from "@angular/forms";

export abstract class FormCanDeactivate extends CanDeactivateComponent {

    abstract get ngFormDirtyCheck(): NgForm;

    canDeactivate(): boolean {
        return this.ngFormDirtyCheck.submitted || !this.ngFormDirtyCheck.dirty;
    }
}

